import { useNewCode } from '@calendly/feature-check-react';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import { FilterMenuFooter } from '@calendly/ui/components/filter-menu';
import { Grid, GridItem } from '@calendly/ui/components/grid';
import { Loader } from '@calendly/ui/components/loader';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { MeetingsFilterMenuContent } from 'components/cui_filter_menu';
import { Error } from './components/error';
const meetingsFilterContentCss = "m1a84ye7";
const gridWrapperUseNewPaddingCss = "g1tte82g";
const gridBodyCss = "g4czil3";
const GridBody = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    useNewPadding = false,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(gridBodyCss, {
    [gridWrapperUseNewPaddingCss]: useNewPadding
  }, props.className)} />;
});
const meetingsFilterFooterCss = "muc8eb5";
const actionsContainerIsPhoneCss = "a11n016t";
const actionsContainerCss = "ak8z21x";
const ActionsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(actionsContainerCss, {
    [actionsContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const buttonTextWrapperIsPhoneCss = "b1t23cq0";
const buttonTextWrapperCss = "b7jvh8u";
const ButtonTextWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(buttonTextWrapperCss, {
    [buttonTextWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const viewMoreButtonCss = "v1mx23fe";
const ViewMoreButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(viewMoreButtonCss, props.className)} />);
const clearButtonIsPhoneCss = "c1o0nb3g";
const clearButtonCss = "c15f01vh";
const ClearButton = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <BareButton ref={ref} {...props} className={classNames(clearButtonCss, {
    [clearButtonIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const BaseFilterModal = ({
  onClose,
  onApply,
  onClear,
  hasError,
  advancedFilters,
  isResultsLoading,
  resultCount,
  children
}) => {
  const isPhone = useDeviceType('isPhone');
  const [showMore, setShowMore] = useState(!!isPhone);
  const useSaFilterSettingsFlag = useNewCode('sa_filter_settings_mtg_pg', false)?.enabled;
  return <MeetingsFilterMenuContent aria-label={I18n.t('publisher.meetings.filter_modal.label')} className={meetingsFilterContentCss} contentTestId="meetings-filter-menu-content" footer={<FilterMenuFooter className={meetingsFilterFooterCss}>
          {isResultsLoading ? <Loader size="small" /> : <BodyText color="muted">
                {I18n.t('publisher.meetings.filter_modal.results', {
        count: resultCount
      })}
              </BodyText>}
          <ActionsContainer>
            <ClearButton decoration="minimal" onClick={onClear}>
              {isPhone ? I18n.t('publisher.action.reset') : I18n.t('publisher.meetings.filter_modal.reset')}
            </ClearButton>
            <Button onClick={onClose} decoration="secondary-outline">
              <ButtonTextWrapper>
                {I18n.t('publisher.action.cancel')}
              </ButtonTextWrapper>
            </Button>
            <Button onClick={onApply}>
              <ButtonTextWrapper>
                {I18n.t('publisher.action.apply')}
              </ButtonTextWrapper>
            </Button>
          </ActionsContainer>
        </FilterMenuFooter>}>
      {hasError && <Error />}
      <GridBody useNewPadding={useSaFilterSettingsFlag}>
        <Grid spacingTop="8">
          {children}
          {!useSaFilterSettingsFlag && !showMore && <GridItem size="12">
                <ViewMoreButton onClick={() => setShowMore(true)}>
                  {I18n.t('publisher.meetings.filter_modal.expand')}
                </ViewMoreButton>
              </GridItem>}
          {!useSaFilterSettingsFlag && showMore && advancedFilters}
          {useSaFilterSettingsFlag && advancedFilters}
        </Grid>
      </GridBody>
    </MeetingsFilterMenuContent>;
};

require("./base_filter_modal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./base_filter_modal.js");